var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('viewer',{attrs:{"images":_vm.imgList}},_vm._l((_vm.imgList),function(row,index){return _c('img',{key:index,staticStyle:{"width":"90px","margin-right":"15px"},attrs:{"src":row}})}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }